import { defineMessages } from 'react-intl';

export default defineMessages({
    twoJobsMessage:{
        id: 'common.MLBundleService.First you will enter your xFirstJob information, then move on to xSecondJob...',
        defaultMessage: 'First you will enter your {firstJob} information, then move on to {secondJob}...'
    },
    completeStepsForJob:{
        id: 'common.MLBundleService.Now, complete the steps necessary for xJob...',
        defaultMessage: 'Now, complete the steps necessary for {job}...'
    },
    completeStepsForPurchase:{
        id: 'common.MLBundleService.Now, complete the necessary steps for purchase...',
        defaultMessage: 'Now, complete the necessary steps for purchase...'
    },
    retrievingBundleDetails:{
        id: 'common.MLBundleService.Retrieving bundle details...',
        defaultMessage: 'Retrieving bundle details...'
    }
    
    
});
